module.exports = __webpack_public_path__ + "static/media/intro.7314f6d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro.mp4
// module id = MqZV
// module chunks = 0